import prestashop from "prestashop";

export type TProduct = {
    image_url: string;
    name: string;
    quantity: number;
    manufacturer_name: string;
    url: string;
    price: string;
    has_discount: boolean;
    discount_type: 'percentage' | 'amount';
    discount_percentage: number;
    price_amount: number;
    price_without_reduction: number;
    limited_series: boolean;
    physical_store_only: boolean;
    quantity_combinations: number;
    out_of_stock: number;
    flags: [{
        label: string;
        type: string;
    }],
};

export type RLXProduct = {
    image_url: string;
    name: string;
    manufacturer_name: string;
    title: string;
    url: string;
    price: string;
};

export default (product: TProduct) => `
    <article class="pb-6 group cursor-pointer" x-data="$defaults('display')" @click="$refs.link.click()">
        <aside class="relative bg-white">
            <picture class="block aspect-square border border-gray-200 relative hoverable:group-hover:border-gold transition-colors">
                <img
                    class="lazy absolute w-full h-full object-contain bg-white"
                    data-src="${product.image_url}"
                    alt="${product.name}"
                    width="378" height="378"
                >
            </picture>


            ${product.flags || product.limited_series || product.physical_store_only ? `
                <ul class="js-product-flags absolute right-2 top-2 gap-y-2 inline-flex flex-col items-end uppercase text-gray-800">
                    ${product.limited_series ? `
                        <li class="text-xxs sm:text-xs border-y border-gold uppercase py-0.5 font-semibold">${prestashop.i18n['Série limitée']}</li>
                    ` : ''}

                    ${product.physical_store_only ? `
                        <li class="text-xxs sm:text-xs border-y border-gold uppercase py-0.5 font-semibold">${prestashop.i18n['Exclu boutique']}</li>
                    ` : ''}

                    ${product.flags.map((flag) => `
                        ${flag.type == 'discount' && product.has_discount ? `
                            <li class="text-gold bg-gold-light px-2 py-1">
                                ${product.discount_type === 'percentage' ? `
                                    ${product.discount_percentage}%
                                ` : ''}

                                ${product.discount_type === 'amount' ? `
                                    ${Math.round((product.price_amount - product.price_without_reduction) / product.price_without_reduction * 100)}%
                                ` : ''}
                            </li>
                        ` : `
                            <li class="text-xxs sm:text-xs border-y border-gold uppercase py-0.5 font-semibold">${flag.label}</li>
                        `}
                    `).join('')}
                </ul>
            ` : ''}

            ${(product.quantity && product.quantity > 0) || (product.quantity_combinations && product.quantity_combinations > 0) ? `
                <span class="absolute uppercase left-2 sm:left-3 top-2 sm:top-3 text-gray-800 text-xs inline-flex items-center before:inline-block before:mr-1 before:h-2 before:w-2 before:rounded-full before:bg-green">
                    ${product.physical_store_only ? `
                         <span class="hidden sm:inline">${prestashop.i18n['Disponible']}</span>
                    ` : `<span class="hidden sm:inline">${prestashop.i18n['Expédié']}</span>&nbsp;24h`}
                </span>
            ` : product.quantity <= 0 && product.out_of_stock == 0 ? `
                <span class="absolute uppercase left-3 top-3 text-gray-600 text-xs inline-flex items-center before:inline-block before:mr-1 before:h-2 before:w-2 before:rounded-full before:bg-red">
                    ${prestashop.i18n['Vendu']}
                </span>
            ` : ''}
        </aside>

        <main class="text-center text-black px-1 py-2 border border-t-0 bg-white relative z-10 border-transparent" :class="{ 'border-gray-200': $store.display.showFeatures }">
            <div class="font-serif uppercase text-sm mb-1">
                ${product.manufacturer_name}
            </div>
            <div class="font-light h-8 line-clamp-2">
                <a href="${product.url}" class="thumbnail product-thumbnail" x-ref="link">
                    ${product.name}
                </a>
            </div>

            <div x-cloak class="font-light text-gray-800 h-4 transition" :class="[$store.display.hidePrices ? 'opacity-0' : 'opacity-100']">
                ${product.price}
                ${product.has_discount ? `
                    <small class="line-through">${product.price_without_reduction}</small>
                ` : ''}
            </div>
        </main>
    </article>
`;
